/*******************************************************************************
**
** GE Aerospace Unified Theme Scripts
**
*******************************************************************************/

import { Toast, Tooltip } from './_bootstrap';

(function ($) {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll('.toast')
    .forEach((toastElement) => new Toast(toastElement));

  // *******************************************************************************************
  // hero
  // *******************************************************************************************
  function heroSecHeight(){
    let hero = document.querySelector(".hero-sec");
    if(hero) {
      let winScrollY = window.scrollY;
      let eleHeight = hero.offsetHeight;
      if (eleHeight <= winScrollY) {
        document.querySelector(".video-wrap").style.display = "none";
        document.querySelector(".video-bg-opacity").style.display = "none";
      }
      else {
        document.querySelector(".video-wrap").style.display = "block";
        document.querySelector(".video-bg-opacity").style.display = "block";
      }
    }
  }
  //
  function textTransformAnimation() {
    var reveals = document.querySelectorAll(".sec");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      if (reveals[i]) {
        var elementTop = reveals[i].getBoundingClientRect().top;
      }
      var elementVisible = 300;
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
  }

  window.addEventListener("scroll", function () {
    let opacityDiv = document.querySelector(".video-bg-opacity");
    if(opacityDiv) {
      let elementHeight = opacityDiv.clientHeight;
      let scrollTop = window.pageYOffset;
      // let videoBg = document.querySelector(".video-bg");
      // let sec1Height = this.document.querySelector(".sec-1");

      if (scrollTop > 100) {
        // videoBg.style.setProperty("-webkit-filter", `blur(${scrollTop / 150}px)`);
        opacityDiv.style.setProperty(
          "opacity",
          `${1 - (elementHeight - scrollTop) / (elementHeight + 1000)}`
        );
      }
      else {
        // videoBg.style.setProperty("-webkit-filter", `inherit`);
        opacityDiv.style.setProperty("opacity", `0.3`);
      }
    }


    // Text Transform animation for hero
    textTransformAnimation();
    heroSecHeight();
  }, false);

  // counter countup for GE9x Hero

  class countUp {
    constructor(el) {
      this.el = el;
      this.setVars();
      this.init();
    }

    setVars() {
      this.number = this.el.querySelectorAll("[data-countup-number]");
      this.observerOptions = { root: null, rootMargin: "0px 0px", threshold: 0 };
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const end = parseFloat(
            entry.target.dataset.countupNumber.replace(/,/g, "")
          );
          const decimals = this.countDecimals(end);
          if (entry.isIntersecting) {
            this.iterateValue(entry.target, end, decimals);
          }
        });
      }, this.observerOptions);
    }

    init() {
      if (this.number.length > 0) {
        this.number.forEach((el) => {
          this.observer.observe(el);
        });
      }
    }

    iterateValue(el, end, decimals) {
      const start = 0;
      const duration = 1500;
      let startTimestamp = null;

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const elapsedPercent = (timestamp - startTimestamp) / duration;
        const easedProgress = Math.min(this.easeOutQuint(elapsedPercent), 1);
        let interimNumber = Math.abs(easedProgress * (end - start) + start);
        el.innerHTML = this.formatNumber(interimNumber, decimals);
        if (easedProgress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      // requestAnimationFrame returns DOMHighResTimeStamp as a callback (used as timestamp)
      window.requestAnimationFrame(step);
    }

    easeOutQuad(x) {
      return 1 - Math.pow(1 - x, 3);
    }

    easeOutQuint(x) {
      return 1 - Math.pow(1 - x, 5);
    }

    countDecimals(val) {
      if (Math.floor(val) === val) return 0;
      return val.toString().split(".")[1].length || 0;
    }

    formatNumber(val, decimals) {
      return val.toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    }
  }

  // Simplifed version of Viget dynamic modules to attach instances for this demo
  // https://www.viget.com/articles/how-does-viget-javascript/
  // You CAN use this pattern, but it's single purpose right now
  const dataModules = [...document.querySelectorAll('[data-module="countup"]')];

  dataModules.forEach((element) => {
    element.dataset.module.split(" ").forEach(function () {
      new countUp(element);
    });
  });

  // *******************************************************************************************
  // end GE9x Hero script
  // *******************************************************************************************
  // model hero

  /*******************************************************************************
  ** Start of Modal functionality
  *******************************************************************************/

  $(document).ready(function () {

    $(".cus-submit").removeClass("btn");
    $('<div>').addClass('uploaded-file-name');
    var extraDiv = $('<div>').addClass('uploaded-file-name');
    $('.attachment-container span').appendTo(extraDiv);
    $('.attachment-container').append(extraDiv);
    // Gets the video src from the data-src on each button
    var $videoSrc;
    $(".watch-btn").click(function () {
      $videoSrc = $(this).data("src");
    });
    // console.log($videoSrc);
    // when the modal is opened autoplay it
    $(".ge-modal-brand-launch-hero").on("shown.bs.modal", function (e) {
      // set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
      $(".ge-modal-brand-launch-hero iframe").attr(
        "src",
        $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0"
      );
    });
    // stop playing the youtube video when I close the modal
    $(".ge-modal-brand-launch-hero").on("hide.bs.modal", function (e) {
      // a poor man's stop video
      $(".ge-modal-brand-launch-hero iframe").attr("src", $videoSrc);
    });

    if ($('.slider-for').length > 0) {
      $(".slider-for").slick({
        slidesToShow: 2.4,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        autoplay: false,
        variableWidth: true,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3.2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1,
            },
          }
        ],
      });
    }
    $(".prev-btn").click(function () {
      $(".slider-for").slick("slickPrev");
    });

    $(".next-btn").click(function () {
      $(".slider-for").slick("slickNext");
    });
    $(".prev-btn").addClass("ctrl-disabled");
    $(".slider-for").on("afterChange", function () {
      if ($(".slick-prev").hasClass("slick-disabled")) {
        $(".prev-btn").addClass("ctrl-disabled");
      } else {
        $(".prev-btn").removeClass("ctrl-disabled");
      }
      if ($(".slick-next").hasClass("slick-disabled")) {
        $(".next-btn").addClass("ctrl-disabled");
      } else {
        $(".next-btn").removeClass("ctrl-disabled");
      }
    });

    /*******************************************************************************
    ** GE Events & Reports
    *******************************************************************************/

    if($(".upcoming-events")) {
      $('.upcoming-events .views-infinite-scroll-content-wrapper').addClass('row');
    }

    if($(".recent-event")) {
      $('.recent-event a').each(function() {
        if(!$(this).hasClass('cal-icons')) {
          $(this).addClass('ge-btn button-primary-light button-icon btn-arrow-right-icon justify-content-start');
        }
        if($(this).attr('target') == '_blank') {
          $(this).removeClass('btn-arrow-right-icon').addClass('btn-arrow-out-icon');
        }
      });
    }


    if($(".masthead-event")) {
      $('.masthead-event a').addClass('ge-btn button-primary-light button-icon btn-arrow-right-icon');
      jQuery('.masthead-event a').each(function(){
        if($(this).attr('target') == '_blank') {
          $(this).removeClass('btn-arrow-right-icon').addClass('btn-arrow-out-icon');
        }
      });
    }

    /*******************************************************************************
    ** End of GE Events & Reports
    *******************************************************************************/
  });

  // If loaded also by ajax
  $(document).on( "ajaxComplete", function() {
    if($(".recent-event")) {
      $('.recent-event a').each(function() {
        if(!$(this).hasClass('cal-icons')) {
          $(this).addClass('ge-btn button-primary-light button-icon btn-arrow-right-icon justify-content-start');
        }
        if($(this).attr('target') == '_blank') {
          $(this).removeClass('btn-arrow-right-icon').addClass('btn-arrow-out-icon');
        }
      });
    }
  });

  /*******************************************************************************
  ** End of Modal functionality
  *******************************************************************************/

  let documentSearch = document.getElementById("ge-document-search");
  if (documentSearch) {
    let refineBtn = document.getElementById("refine-mobile-btn");
    let refineMobiileSection = document.getElementById("refine-list-mobile");
    let wholeListSection = document.getElementById("whole-list");
    let bodyElem = document.querySelector("body");

    const showHideRefineSection = (showRefineSection, listSection) => {
      showRefineSection ? refineMobiileSection.classList.add("refine-list-mobile") : refineMobiileSection.classList.remove("refine-list-mobile");
      showRefineSection ? bodyElem.style.overflow="hidden" : bodyElem.style.overflow="auto"
      wholeListSection.style.display = listSection;
    }

    if (refineBtn) {
      refineBtn.addEventListener('click', () => {
        window.scrollTo(0, 0);
        showHideRefineSection(true, "none")
      })      
      if (document.getElementById("btn-close-icon")) {
        document.getElementById("btn-close-icon").addEventListener('click', () => {
          showHideRefineSection(false, "unset");
        })
      }      
      if (document.getElementById("apply")) {
        document.getElementById("apply").addEventListener('click', () => {
          showHideRefineSection(false, "unset");
        })
      }
      window.addEventListener('resize', () => {
        if (document.body.clientWidth > 768) {
          showHideRefineSection(false, "unset");
        }
      });
    }
  }

  let documentSearchFilter = document.getElementById("ge-articles-filter");
  function pagecnt(){
    let pagecount = document.getElementById("pagecount");
    let value = pagecount.value;
    let text = pagecount.options[pagecount.selectedIndex].text;
  }

  if (document.getElementById('clearall')) {
    document.getElementById('clearall').onclick = function(event) {
      var checkboxes = document.getElementsByName('category');
      for (var checkbox of checkboxes) {
        checkbox.checked = false;
        event.preventDefault();
      }
    }
  }

  if (document.getElementById('clearall-mobile')) {
    document.getElementById('clearall-mobile').onclick = function(event) {
      var checkboxes = document.getElementsByName('category');
      for (var checkbox of checkboxes) {
        checkbox.checked = false;
        event.preventDefault();
      }
    }
  }

  if (documentSearchFilter){
    let refineBtn= document.getElementById("refine-mobile-btn");
    let refineMobiileSection = document.getElementById("refine-list-mobile");
    let wholeListSection = document.querySelector(".list-section");
    let topbannersection = document.querySelector(".top-img-container");
    let bodyElem = document.querySelector("body");

    const showHideRefineSection = (showRefineSection, listSection) => {
      showRefineSection ? refineMobiileSection.classList.add("refine-list-mobile") : refineMobiileSection.classList.remove("refine-list-mobile");
      showRefineSection ? bodyElem.style.overflow="hidden" : bodyElem.style.overflow="auto";
      wholeListSection.style.display = listSection;
      topbannersection.style.display = listSection;
    }

    if(refineBtn){
      refineBtn.addEventListener('click',  ()=> {
        window.scrollTo(0, 0);
        showHideRefineSection(true, "none")
      })
      if (document.getElementById("btn-close-icon")) {
        document.getElementById("btn-close-icon").addEventListener('click', () => {
          showHideRefineSection(false, "block");
        })
      }
      window.addEventListener('resize', () => {
        if (document.body.clientWidth > 768) {
          showHideRefineSection(false, "block");
        }
      });
    }
  }

  const updateTypeField = () => {
    let sector = jQuery('select[name="field_commercial_engine_sector_target_id"]').val();
    let selected_type = jQuery('select[name="field_commercial_engine_type_target_id"]').val();
    const tree = drupalSettings.taxonomy_tree.commercial_engine;
    let term, types = [];
    for (let i = 0; i < tree.length; i++) {
      term = tree[i];
      if (term.parents[0] == sector) {
        types.push(term);
      }
    }
    let option = jQuery('<option></option>').attr("value", "All").text("- Any -");
    jQuery('select[name="field_commercial_engine_type_target_id"]').empty().append(option);
    for (let j = 0; j < types.length; j++) {
      option = jQuery('<option></option>').attr("value", types[j].tid).text(types[j].name);
      jQuery('select[name="field_commercial_engine_type_target_id"]').append(option);
    }
    if (selected_type != 'All' || selected_type != null || selected_type != undefined) {
      jQuery('select[name="field_commercial_engine_type_target_id"]').val(selected_type);
    } else {
      jQuery('select[name="field_commercial_engine_type_target_id"]').val('All');
    }
  }

  jQuery(document).on('change', 'select[name="field_commercial_engine_sector_target_id"]', function() {
    updateTypeField();
  });

  jQuery(document).ready(function() {
    const parentElement = document.querySelectorAll('[data-drupal-views-infinite-scroll-content-wrapper]');
    if (parentElement[0]) {
      const hasChild = parentElement[0].firstElementChild.classList.contains('commercial-defense-engine');

      if (hasChild) {
        parentElement[0].classList.add('row');
      }
    }

    const commercial_submit = document.getElementById('edit-submit-commercial-engine-filter');
    let commercialButtonElement = document.createElement('button');
    if (commercial_submit) {
      commercial_submit.classList.remove('btn');
      commercial_submit.classList.remove('btn-primary');
      for (const attribute of commercial_submit.attributes) {
        commercialButtonElement.setAttribute(attribute.name, attribute.value);
      }
      commercialButtonElement.textContent = commercial_submit.value;
      commercial_submit.parentNode.replaceChild(commercialButtonElement, commercial_submit);
    }

    const defense_submit = document.getElementById('edit-submit-defence-engine-filter');
    let defenseButtonElement = document.createElement('button');
    if (defense_submit) {
      defense_submit.classList.remove('btn');
      defense_submit.classList.remove('btn-primary');
      for (const attribute of defense_submit.attributes) {
        defenseButtonElement.setAttribute(attribute.name, attribute.value);
      }
      defenseButtonElement.textContent = defense_submit.value;
      defense_submit.parentNode.replaceChild(defenseButtonElement, defense_submit);
    }

    let urlParams = new URLSearchParams(window.location.search);
    let sector = urlParams.get('field_commercial_engine_sector_target_id');

    if(sector) {
      updateTypeField();
    }

    if (urlParams.has('field_commercial_engine_sector_target_id') || urlParams.has('field_commercial_engine_type_target_id') || urlParams.has('field_defence_engine_sector_target_id')) {
      const contentSection = document.getElementById('ge-articles-filter');
      if (contentSection) {
        contentSection.scrollIntoView();
      }
    }
  });

})(jQuery);